export const NAMESPACE = 'well-completion/cementing-design';

// PROJECT MANAGER
// ==========================================================================

export const INIT_PROJECTS = `${NAMESPACE}/INIT_PROJECTS`;
export const SELECT_PROJECTS = `${NAMESPACE}/SELECT_PROJECTS`;
export const ADD_PROJECT = `${NAMESPACE}/ADD_PROJECT`;
export const REMOVE_PROJECT = `${NAMESPACE}/REMOVE_PROJECT`;
export const UPDATE_PROJECT = `${NAMESPACE}/UPDATE_PROJECT`;

// PROJECT GENERAL INPUT
// ==========================================================================
export const UPDATE_PROJECT_INPUT_GENERAL = `${NAMESPACE}/UPDATE_PROJECT_INPUT_GENERAL`;
export const UPDATE_PROJECT_INPUT_PRESSURE = `${NAMESPACE}/UPDATE_PROJECT_INPUT_PRESSURE`;
export const UPDATE_PROJECT_INPUT_CEMENT_PROGRAM = `${NAMESPACE}/UPDATE_PROJECT_INPUT_CEMENT_PROGRAM`;

export const UPDATE_PROJECT_OUTPUT = `${NAMESPACE}/UPDATE_PROJECT_OUTPUT`;
export const UPDATE_PROJECT_OUTPUT_PUMP = `${NAMESPACE}/UPDATE_PROJECT_OUTPUT_PUMP`;
export const UPDATE_PROJECT_OUTPUT_SUMMARY = `${NAMESPACE}/UPDATE_PROJECT_OUTPUT_SUMMARY`;
export const UPDATE_PROJECT_OUTPUT_KEY_INFO = `${NAMESPACE}/UPDATE_PROJECT_OUTPUT_KEY_INFO`;

// CASING SELECTION
// ==========================================================================

export const SELECT_CASINGS = `${NAMESPACE}/SELECT_CASINGS`;
export const SELECT_CEMENTS = `${NAMESPACE}/SELECT_CEMENTS`;

// SETTINGS
// ==========================================================================

export const UPDATE_SETTINGS = `${NAMESPACE}/UPDATE_SETTINGS`;

// CONTROLLER SELECTION
// ==========================================================================

export const SELECT_CURRENT_LAYOUT = `${NAMESPACE}/SELECT_CURRENT_LAYOUT`;
